import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import BranchMenu from "@ignitesales/neuro-application/src/neuro-guide/components/BranchMenu";
import ClientLogo from "./DialogueClientLogo";
import RenderOnlyFor from '@ignitesales/neuro-application/src/neuro-guide/components/RenderOnlyFor';
import { useDialogueGuideSettings } from '../hooks/useDialogueGuideSettings.mjs';
import NotesComponent from './NotesComponent';

const BasicHeader = ({ className }) => {
    const componentClass = 'basicHeader';
    const classes = classnames('header', componentClass, className);
    const { shouldAllowNotesFunctionality } = useDialogueGuideSettings();

    return (
        <header className={classes}>
            <div className='container'>
                <div className={`${componentClass}__logo`}>
                    <ClientLogo />
                </div>
                <RenderOnlyFor forLandingPage={true} forSummaryPage={true} forSurveyPage={true}>
                    <BranchMenu>
                        {shouldAllowNotesFunctionality && <NotesComponent />}
                    </BranchMenu>
                </RenderOnlyFor>
            </div>
        </header>
    );
};

BasicHeader.propTypes = {
    className: PropTypes.string
};

export default BasicHeader;
